import html2canvas from 'html2canvas'
import { useCallback, useState } from 'react'

const useRechartsToPng = () => {
  const [png, setPng] = useState(null)

  const ref = useCallback(
    async (node) => {
      if (node !== null && 'container' in node) {
        const data = await html2canvas(node.container).then((canvas) => {
          return canvas.toDataURL('image/png', 1)
        })
        setPng(data)
      }

      else if (node !== null && node.dataset.type === 'chart-container') {
        const data = await html2canvas(node).then((canvas) => {
          return canvas.toDataURL('image/png', 1)
        })
        setPng(data)
      }
    },
    []
  )

  // const ref = useCallback(
  //   async (node) => {
  //     if (node !== null) {
  //       let element = null

  //       // Recharts
  //       if ('container' in node) {
  //         element = node.container
  //       }

  //       // Regular HTML
  //       else {
  //         element = node
  //       }

  //       const data = await html2canvas(element, options).then((canvas) => {
  //         return canvas.toDataURL('image/png', 1)
  //       })

  //       setPng(data)
  //     }
  //   },
  //   [options]
  // )

  return [png, ref]
}

export { useRechartsToPng }
